import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";
import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";
import styles from "./../tooltip.module.css";

import ChangeCreditLimitModal from "../LimitLevels/ChangeCreditLimitModal";
import ChangeLevelModal from "../LimitLevels/ChangeLevelModal";
//import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
import SearchBar from "../SearchBar";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import CobranzaKPITable from "./CobranzaKPITable";
import CreateAbono from "./CreateAbono";
import {
  buildName,
  getMonthNames2,
  getWeekDays,
  Singleton,
} from "helper/tools";
import { es } from "date-fns/locale";
import { format } from "date-fns";
import { MdOutlineFileDownload } from "react-icons/md";
import ExportCSV from "../ExportCSV";
import { handleStatus } from "../../helperFunctions/helpers";

export default function CobranzaHistorial() {
  const Menus = {
    FechaOrden: 0,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const DocumentacionValues = {
    Con: 0,
    Sin: 1,
  };

  const createAbonoRef = useRef();

  const rangeCredito = useRef(null);

  const createAsociadosRef = useRef();
  const filtrosRef = useRef([]);
  const changeCreditLimitRef = useRef();
  const changeLevelRef = useRef();
  const resizeRef = useRef();

  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const csvRef = useRef();

  //const selectedFechaOrdenItem = useRef(null);

  const selectedFechaOrdenItem = useRef({ start: new Date(), end: new Date() });

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [docu, setDocu] = useState([
    {
      nombre: "Con",
      value: DocumentacionValues.Con,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Sin",
      value: DocumentacionValues.Sin,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros] = useState([
    {
      type: Menus.FechaOrden,
      name: "Fecha Orden",
    },
  ]);

  /** FILTERS */
  const [kpiData, setKpiData] = useState([]);
  const [niveles, setNiveles] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  useEffect(() => {
    console.log("--->");
    configureDatePicker();

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        /*ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },*/
      },
      function (start, end, label) {
        var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");
        const date = start.toDate();
        //selectedDate.current = { start: start.toDate(), end: end.toDate() };
        //fetchData();

        handleFechaOrdenClick(null, {
          start: start.toDate(),
          end: end.toDate(),
        }); //selectedDate.current);
      },
    );

    dateRangeEleRef.current.addEventListener("apply.daterangepicker", (e) => {
      console.log("---> " + e);
    });

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  const handleFechaOrdenClick = (event, item, options) => {
    updateFechaOrdenCriteria(item);
  };

  const updateFechaOrdenCriteria = (value) => {
    selectedFechaOrdenItem.current = value;

    //onClick(item, options);
    let criteria = searchCriteria;
    criteria["FechaOrden"] = selectedFechaOrdenItem.current;
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    /* mantener la posicions pagina
        pagingInfoRef.current.resetPageInfo();
        */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.FechaOrden;
    });

    if (index === -1) {
      return;
    }
    var name = "";
    if (selectedFechaOrdenItem.current != null) {
      name =
        format(selectedFechaOrdenItem.current.start, "MMM dd, yyyy ") +
        format(selectedFechaOrdenItem.current.end, "MMM dd, yyyy");
    }
    //
    /*const statusFilter = bodegaStatuses.filter((currItem) => {
          return selectedFechaOrdenItem.current === currItem.id;
        });
    
        name = statusFilter
          .map(function (status) {
            return status.nombre;
          })
          .join(", ");*/

    filtrosRef.current[index].toka(name);
  };

  function clearFechaOrdenFilter(s) {
    updateFechaOrdenCriteria(null);

    //  filtrosRef.current[Menus.FechaOrden].hideMenu();
  }

  function configureDatePicker() {
    // load current Day
    const startDate = new Date();
    startDate.setHours(0, 0, 0);
    handleFechaOrdenClick(null, { start: startDate, end: startDate });

    const daysOfWeek = getWeekDays(es);
    const monthNames = getMonthNames2(es);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
          cancelLabel: "Cancelar",
          applyLabel: "Aplicar",
          weekLabel: "S#",
          daysOfWeek: daysOfWeek,
          monthNames: monthNames,
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,
        showWeekNumbers: true,

        startDate: startDate,

        //minDate: startDate,
        //maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)

        timePicker: false,
      },
      function (start, end, label) {
        //  var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");
        startDate.setHours(0, 0, 0);

        handleFechaOrdenClick(null, { start: start, end: start });
      },
    );

    //let selectedDateRange = "";
    /*  if (startDate != null || endDate != null) {
        //
        const lastMonthStart = new Date();
        lastMonthStart.setDate(1);
        lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
        const lastMonthEnd = new Date(lastMonthStart);
        lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
        lastMonthEnd.setDate(-1);
  
        //
        selectedDateRange.current =
          format(startDate, "MMM dd, yyyy") +
          " - " +
          format(endDate, "MMM dd, yyyy");
      }*/
  }

  const fetchData = async () => {
    /* setIsLoading(true);
    const responseNiveles = await api.niveles().catch((error) => {
      toast.error("Error al pedir Niveles.");
      setIsLoading(false);
    });

    if (!responseNiveles) {
      setIsLoading(false);
      return;
    }

    const autoNiveles = responseNiveles.data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });

    setNiveles(autoNiveles); 
    setIsLoading(false); */

    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  function createAsociado(event) {
    console.log(event);
    loadItem({});
  }

  function reloadAsociados() {
    fetchData();
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalData(item);

    //createAsociadosRef.current.toggleModal();
    createAbonoRef.current.toggleModal();
  }

  async function detailItem(itemIndex, finishCallback) {
    if (isNaN(itemIndex) || itemIndex < 0) {
      finishCallback();
      return;
    }

    const item = kpiData[itemIndex];
    const asociadoId = item.asociado.id;

    const criteria = { asociadoId: asociadoId };
    const response = await api
      .asociadoCobranzaDetalle(criteria)
      .catch((error) => {
        toast.error("Error al buscar Detalle de Asociado.");
        setIsLoading(false);
        finishCallback();
      });
    if (!response) return;

    console.log("---");
    //const data = response.data.subset;
    kpiData[itemIndex].clientes = response.data.subset;

    const newKpiData = JSON.parse(JSON.stringify(kpiData));

    setKpiData(newKpiData);
    finishCallback();
  }

  function openChangeCreditLimit(event, data) {
    console.log(event);
    setModalData(data);
    changeCreditLimitRef.current.toggleModal();
  }

  function openChangeLevel(event, data) {
    console.log(event);
    setModalData(data);
    changeLevelRef.current.toggleModal();
  }

  /**
   * Search handler
   */
  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    if (e === null) {
      delete criteria["texto"];
    } else {
      criteria["texto"] = e;
    }

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearNivelesFilter(s) {
    niveles.forEach((item) => {
      item.checked = false;
    });

    setNiveles(niveles.slice());

    updateNivelesCriteria([]);

    filtrosRef.current[Menus.Niveles].hideMenu();
  }

  const handleNivelesClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["NivelIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateNivelesCriteria(nivelIds);
  };

  const updateNivelesCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["NivelIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Niveles;
    });

    if (index === -1) {
      return;
    }
    var nivelesNames = "";
    if (nivelIds.length > 0) {
      //
      const nivelesFilter = niveles.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      nivelesNames = nivelesFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(nivelesNames);
  };

  function clearCreditoRange(s) {
    handleCreditoRangeChange("");
    filtrosRef.current[Menus.CreditoRange].hideMenu();
  }

  const handleCreditoRangeChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;
      //currentStatus[item.pos] = event.currentTarget.checked;

      criteria["creditoRange"] = aRange;
    } else {
      delete criteria["creditoRange"];
    }

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const clearDocumentacionFilter = () => {
    docu.forEach((item) => {
      item.checked = false;
    });

    setDocu(docu.slice());

    updateDocuCriteria(undefined);

    filtrosRef.current[Menus.Documentacion].hideMenu();
  };

  function clearLimiteCreditoRange(s) {
    handleLimiteCreditoRangeChange("");
    filtrosRef.current[Menus.CreditoRange].hideMenu();
  }

  function clearCreditoPercentageRange(s) {
    handleCreditoRangePercentageChange("");
    filtrosRef.current[Menus.CreditoDispuestoRange].hideMenu();
  }

  function clearCreditoDisponibleRange(s) {
    handleCreditoRangeDisponibleChange("");
    filtrosRef.current[Menus.CreditoDisponibleRange].hideMenu();
  }

  const handleLimiteCreditoRangeChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;

      criteria["LimiteCreditoRange"] = aRange;
    } else {
      delete criteria["LimiteCreditoRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.LimiteCreditoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangePercentageChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str);
      });

      rangeCredito.current = aRange;

      criteria["CreditoPorcentajeRange"] = aRange;
    } else {
      delete criteria["CreditoPorcentajeRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoDispuestoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangeDisponibleChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;

      criteria["CreditoDisponibleRange"] = aRange;
    } else {
      delete criteria["CreditoDisponibleRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.current.resetPageInfo();
    //criteria = pagingInfoRef.current.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoDisponibleRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.FechaOrden && item.type === Menus.FechaOrden) {
        clearFechaOrdenFilter();
      }
    });
  }

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const handleDocuClick = (event, item, options) => {
    item.checked = !item.checked;

    const isCon = docu.find((item) => {
      return item.value === DocumentacionValues.Con && item.checked;
    })?.checked;
    const isSin = docu.find((item) => {
      return item.value === DocumentacionValues.Sin && item.checked;
    })?.checked;

    let checked = isCon;
    if (!(isCon ^ isSin)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isSin) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateDocuCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const updateDocuCriteria = (docuValue) => {
    let criteria = searchCriteria;
    if (docuValue === undefined) {
      delete criteria["HasDocumentacion"];
    } else {
      criteria["HasDocumentacion"] = docuValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Documentacion;
    });

    if (index === -1) {
      return;
    }
    var docusNames = "";
    //
    const docuses = docu.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    docusNames = docuses.join(", ");

    filtrosRef.current[index].toka(docusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);

    const response = await api
      .searchCobranzaAsociados(criteria)
      .catch((error) => {
        toast.error("Error al buscar Clientes.");
        setIsLoading(false);
      });
    if (!response) return;

    setKpiData(response.data.subset);

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    //  setAsociados(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados
    const pagosFechas = ["31/10/2025", "15/11/2025"];

    const csvString = [
      [
        "NumAsociado",
        "AsociadoNombre",
        "AsociadoApellido",
        "CreditoDisponible",
        "NumCliente",
        "ClienteNombre",
        "ClienteApellido",
        "OrdenId",
        "NumProducto",
        "ProductoNombre",
        "ProductoPrecio",
        "FechaEntrega",
        ...pagosFechas,
      ], // Specify your headers here
      ...kpiData.map((item) => {
        //--
        const numAsociado = item.asociado.numAsociado ?? "-";
        const nombreAsociado = item.asociado.nombre ?? "";
        const apellidoAsociado = item.asociado.apellidoPaterno ?? "";

        const totalPagar = Singleton.getInstance().format(item.total);
        const pendienteTotalParcialidad = Singleton.getInstance().format(
          item.pendienteTotalParcialidad,
        );

        const ordenParcialidades = item.ordenParcialidades;
        const parcialidadActual = ordenParcialidades.parcialidadActual;
        const parcialidadTotal = ordenParcialidades.totalParcialidades;
        const numPago = `${parcialidadActual + 1} / ${parcialidadTotal}`;

        const parcialidad = ordenParcialidades.parcialidades[parcialidadActual];
        const pagoRequerido = Singleton.getInstance().format(parcialidad.total);

        //const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");
        const fechaInicial = format(parcialidad.fechaInicio, "dd-MMM-yyyy");
        const fechaFin = format(parcialidad.fechaFin, "dd-MMM-yyyy");
        //const fechaRango = `${fechaInicial} - ${fechaFin}`;
        const fechaRango = `${fechaInicial}`;

        //  const start = new Date();
        /*start.setMonth(monthIndex);
                                        start.setDate(1);*/
        //  const clientes = asociadosClientes[item.id] ?? [];
        const clientes = item.clientes;
        //------[
        const clientesMaps = clientes.map((item) => {
          const numCliente = item.cliente?.numCliente ?? "-";
          const nombreCliente = item.cliente?.nombre ?? "";
          const apellidoCliente = item.cliente?.apellidoPaterno ?? "";

          const orderId = "343"; //item.orderVenta.id;

          const totalPagar = Singleton.getInstance().format(item.total);

          const pendienteTotalParcialidad = Singleton.getInstance().format(
            item.pendienteTotalParcialidad,
          );

          const ordenParcialidades = item.ordenParcialidades;
          const parcialidadActual = ordenParcialidades.parcialidadActual;
          const parcialidadTotal = ordenParcialidades.totalParcialidades;
          const numPago = `${parcialidadActual + 1} / ${parcialidadTotal}`;

          const parcialidad =
            ordenParcialidades.parcialidades[parcialidadActual];
          const pagoRequerido = Singleton.getInstance().format(
            parcialidad.total,
          );

          const fechaInicial = format(parcialidad.fechaInicio, "dd-MMM-yyyy");
          const fechaFin = format(parcialidad.fechaFin, "dd-MMM-yyyy");
          const fechaRango = `${fechaInicial} - ${fechaFin}`;
          //const fechaRango = `${fechaInicial}`;

          return [
            "",
            "",
            "",
            "",
            numCliente,
            nombreCliente,
            apellidoCliente,
            orderId,
            totalPagar,
            pendienteTotalParcialidad,
            parcialidadActual,
            parcialidadTotal,
            numPago,
            pagoRequerido,
            fechaRango,
          ];
        });
        ///-------]

        //--
        //  const id = item.numProducto ?? "";

        return [
          [
            numAsociado,
            nombreAsociado,
            apellidoAsociado,
            "",
            "",
            "",
            totalPagar,
            "Credito",
            "numclient",
            item.nombre ?? "",
            item.marca?.nombre ?? "",
            item.genero?.nombre ?? "",
            item.tamaño?.nombre ?? "",
            item.concentracion?.nombre ?? "",
            handleStatus(item).text,
          ],
          ...clientesMaps,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "productosCatalogo.csv");
  }

  async function openEstadoCuenta(itemIndex, finishCallback) {
    if (isNaN(itemIndex) || itemIndex < 0) {
      if (finishCallback != null) finishCallback();
      return;
    }

    const item = kpiData[itemIndex];
    const asociadoId = item.asociado.id;

    const criteria = { asociadoId: asociadoId };
    const response = await api
      .asociadoCobranzaEstadoCuenta(criteria)
      .catch((error) => {
        toast.error("Error al buscar Detalle de Asociado.");
        setIsLoading(false);
        if (finishCallback != null) finishCallback();
      });
    if (!response) return;

    /// name file, fallback random
    const secondsSinceEpoch = Math.floor(Date.now() / 1000);
    let fileName = `Estado_Cuenta_${secondsSinceEpoch}.pdf`;

    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition) {
      const fileNameMatch = contentDisposition
        .matchAll(/filename=(.*?)(;|$)/g)
        .toArray()[0][1];
      fileName = fileNameMatch.replace(/"/g, "");
      console.log("File Name:", fileName);
    }

    // 1. Create a URL for the Blob
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a temporary URL for the blob object
    //  const url = window.URL.createObjectURL(blob);

    // To Open in new tab:
    //  window.open(url);

    /*
    https://www.google.com/search?q=web+api+c%23+download+file+and+open&client=firefox-b-d&hs=WgQ&sca_esv=8eb5eb78efc6b1d8&sxsrf=ANbL-n6yfXnM9yY3j1foZcV3t3SaabxSbw%3A1776970046106&ei=PmnqaYubBrfwkPIPiaWB8AY&biw=1426&bih=834&ved=0ahUKEwiLsv-i0YSUAxU3OEQIHYlSAG4Q4dUDCBE&uact=5&oq=web+api+c%23+download+file+and+open&gs_lp=Egxnd3Mtd2l6LXNlcnAiIXdlYiBhcGkgYyMgZG93bmxvYWQgZmlsZSBhbmQgb3BlbjIFECEYoAFIio8BUL8FWJeIAXABeAGQAQCYAc4BoAGKEKoBBTguOS4xuAEDyAEA-AEBmAIToALzEcICChAAGLADGNYEGEfCAgQQIxgnwgIKECMYgAQYJxiKBcICERAuGIAEGLEDGNEDGIMBGMcBwgIIEAAYgAQYsQPCAgoQABiABBhDGIoFwgILEAAYgAQYsQMYgwHCAgsQLhiABBjRAxjHAcICEBAAGIAEGLEDGEMYgwEYigXCAggQLhiABBixA8ICDRAAGIAEGLEDGEMYigXCAgcQABiABBgKwgIWEC4YgAQYsQMY0QMYQxiDARjHARiKBcICBRAAGIAEwgIGEAAYChgewgIEEAAYHsICCRAAGIAEGAoYC8ICBxAjGLECGCfCAgYQABgWGB7CAggQABgWGAoYHsICBRAAGO8FwgIFECEYnwXCAgQQIRgVmAMA4gMFEgExIECIBgGQBgiSBwYyLjE2LjGgB8B0sgcGMS4xNi4xuAfaEcIHCTAuMy42LjguMsgHsgGACAA&sclient=gws-wiz-serp
    */

    // To Download:
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    console.log("---");

    //  kpiData[itemIndex].clientes = response.data.subset;

    //    const newKpiData = JSON.parse(JSON.stringify(kpiData));

    //  setKpiData(newKpiData);
    //  finishCallback();

    // 4. Free up memory
    window.URL.revokeObjectURL(url);
    //document.body.removeChild(a);
  }

  return (
    <>
      <ExportCSV ref={csvRef} />
      <CreateAbono
        ref={createAbonoRef}
        item={modalData}
        reloadOrdenes={reloadAsociados}
      />

      <div className="">
        <div className="bd-example">
          <div className="container  overflow-hidden">
            <div className="row  gx-5">
              <div
                className="col card1 recent-sales overflow-auto"
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "0px",
                  marginBottom: "30px",
                }}
              ></div>

              <div
                className="col card1 recent-sales overflow-auto"
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "0px",
                  marginBottom: "30px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className="card recent-sales overflow-auto">
        <ChangeCreditLimitModal ref={changeCreditLimitRef} item={modalData} />

        <ChangeLevelModal ref={changeLevelRef} item={modalData} />

        <div className="separator"></div>
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className="header">
              <SearchBar onChange={(e) => onChangeSearchText(e)} />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginRight: "40px" }}
                disabled={isLoading}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>
              <button
                className="btn btn-primary"
                onClick={createAsociado}
                hidden={true}
              >
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Asociado
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            >
              {filtros.map((filtro, index) => {
                return (
                  <>
                    <FilterButton
                      key={index}
                      ref={(el) => (filtrosRef.current[index] = el)}
                      name={filtro.name}
                      clearCallback={(ble) => clearCallback(filtro)}
                      tap={(e, show) => {
                        console.log("---> WE");

                        if (filtro.type === Menus.FechaOrden) {
                          if (show) {
                            setTimeout(() => {
                              dateRangeRef.current.show();
                            }, 200);
                          } else {
                            dateRangeRef.current.hide();
                          }
                        }
                      }}
                    >
                      <ul
                        className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                        aria-labelledby="dropdownMenuClickableInside"
                      >
                        {filtro.type === Menus.FechaOrden && (
                          <>
                            <div
                              ref={dateRangeEleRef}
                              type="text"
                              name="birthday"
                              value=""
                              style={{ visibility: "collapse" }}
                            />

                            {/** <div
                              id="daterange"
                              className="selectbox pull-right"
                              onClick={() => {
                                console.log("-->>ZZZ");
                                //  dateRangeRef.current.toggle();
                              }}
                              style={{ display: "none" }}
                            >
                              <FaRegCalendarAlt style={{ fontSize: "20px" }} />
                              <span>{selectedDateRange.current}</span>{" "}
                              <b className="caret"></b>
                            </div>  */}
                          </>
                        )}
                      </ul>
                    </FilterButton>
                  </>
                );
              })}
            </div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item, index) => {
              let page = pagingInfoRef.current.pageNumber();
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  key={index}
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>
        {/** */}
        <div className="card-body">
          <CobranzaKPITable
            items={kpiData}
            openItem={loadItem}
            handleDetail={detailItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
            openEstadoCuenta={openEstadoCuenta}
          />
        </div>
      </div>
    </>
  );
}
